import * as Library from '../../../../lib/core/library/index';

export class Option {
  public optionCd: string;
  public marketingName: string;
  public marketingLongName: string;
  public optionType: string;
  public packageInd: boolean;
  public msrp: number;

  isInterior() {
    return false;
  }

  isEterior() {
    return false;
  }

  /*
   * Constructor()
   */
  constructor();
  constructor(options: object);
  constructor(options?: any) {
    this.optionCd = Library.init(options, 'optionCd');
    this.marketingName = Library.init(options, 'marketingName');
    this.marketingLongName = Library.init(options, 'marketingLongName');
    this.optionType = Library.init(options, 'optionType');
    this.packageInd = Library.init(options, 'packageInd', false);
    this.msrp = Library.init(options, 'msrp', 0);
  }
}
